import React from 'react';
import { Button } from './ui/Button';
export function FinalCTASection() {
  return <section className="w-full bg-gray-900 py-12 px-4 md:px-8 text-center" data-id="element-49">
      <div className="max-w-4xl mx-auto" data-id="element-50">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-5" data-id="element-51">
          ¿Lista para transformar tu año en primaria?
        </h2>

        <p className="text-xl text-gray-300 mb-6" data-id="element-52">
          Sumate a maestras que ya dejaron de improvisar.
        </p>

        <a href="https://mi-tienda-pro-8012.myshopify.com/cart/48041308586203:1" data-id="element-53">
          <Button pulse className="text-xl md:text-2xl px-12 py-5" data-id="element-54">
            👉 QUIERO EMPEZAR AHORA
          </Button>
        </a>
      </div>
    </section>;
}